import { useState, type FormEvent } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/dah80kbp14a1h3mr6eq0";

export default function NewsletterSection() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get("website_alt") ?? "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("订阅成功，我们会把每日精选发到你的邮箱。");
      form.reset();
      return;
    }
    formData.delete("website_alt");

    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      payload.append(key, String(value));
    });

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText) as typeof parsed;
      } catch {
        parsed = null;
      }

      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const isSpam = typeof serverMsg === "string" && serverMsg.toLowerCase().includes("spam");

      if (response.ok && parsed?.code === "OK") {
        setStatus("success");
        setMessage("订阅成功，我们会把每日精选发到你的邮箱。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(isSpam ? "提交未通过校验，请检查后重试。" : serverMsg || "提交失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后再试。");
    }
  };

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20abstract%20gradient%20of%20amber%20and%20deep%20red%20soft%20light%20waves%2C%20minimal%20elegant%20background%20texture%2C%20editorial%20clean%20composition&width=1600&height=600&seq=gossip-newsletter-bg&orientation=landscape"
          alt="爆料专区每日提醒背景"
          title="爆料专区每日提醒"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-foreground-950/75"></div>
      </div>

      <div className="relative mx-auto w-full max-w-3xl px-4 py-14 text-center md:px-8 md:py-20">
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-4 py-1 text-xs font-medium text-primary-950">
          <i className="ri-notification-3-line"></i>
          每日爆料提醒
        </span>
        <h2 className="mt-4 font-heading text-2xl tracking-wide text-background-50 md:text-4xl">
          别错过今天的那口瓜
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-background-100/85">
          留下邮箱，我们每天把最值得看的三条爆料整理成一封短信，早上十分钟，热点全知道。
        </p>

        <form
          id="newsletter-form"
          data-readdy-form
          onSubmit={handleSubmit}
          className="mx-auto mt-8 flex w-full max-w-lg flex-col gap-3 sm:flex-row"
        >
          <label htmlFor="newsletter-email" className="sr-only">
            邮箱地址
          </label>
          <input
            id="newsletter-email"
            type="email"
            name="email"
            required
            autoComplete="email"
            placeholder="请输入你的邮箱"
            className="h-12 flex-1 rounded-md border border-background-50/20 bg-background-50/95 px-4 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 focus:border-accent-400 focus:ring-2 focus:ring-accent-400/40"
          />
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="field-website-alt"
          />
          <button
            type="submit"
            className="flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            立即订阅
            <i className="ri-send-plane-line"></i>
          </button>
        </form>

        {status !== "idle" && (
          <p
            className={`mt-4 text-sm ${
              status === "success" ? "text-accent-200" : "text-primary-200"
            }`}
          >
            {status === "success" ? "✓ " : "! "}
            {message}
          </p>
        )}
      </div>
    </section>
  );
}